// ANCHOR Model
import { createNullaryModel, createSelector, createSelectors } from 'react-scoped-model';

// ANCHOR Hooks
import { useToggle } from '@lyon/utils/hooks/useToggle';

// ANCHOR Utils
import { tuple } from '@lyon/utils/tuple';

export const UpdateFormModalVisibility = createNullaryModel(
  () => useToggle(false),
  {
    displayName: 'Models.UpdateFormModalVisibility',
  },
);

export const useUpdateFormModalVisibilityShow = createSelector(
  UpdateFormModalVisibility,
  (state) => state.show,
);

export const useUpdateFormModalVisibilityHide = createSelector(
  UpdateFormModalVisibility,
  (state) => state.hide,
);

export const useUpdateFormModalVisibilityStateAndHide = createSelectors(
  UpdateFormModalVisibility,
  (state) => tuple(
    state.state,
    state.hide,
  ),
);
